/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { v4 as uuidv4 } from "uuid";
import { XIcon } from "@heroicons/react/solid";
import { openDB } from 'idb';
import DeleteIcon from '@mui/icons-material/Delete';
import Select from "react-select"
const multiItemDetailsDemoObject = {
    item_multi_name: "",
    item_multi_price: 0,
    menu_item_multi_uuid: ""
}
const addonItemDetailsDemoObject = {
    item_uuid: "",
    menu_item_addon_uuid: "asdfasd",
    price: 0,
}
const ItemEditPopup = ({ close, setCurrentMenu, Menu, categoryId, itemId }) => {
    const [multiServing, setMultiServing] = useState({
        multi_max: "1",
        multi_min: "1",
        multi_title: "",
        multi_item_details: [{
            item_multi_name: "",
            item_multi_price: 0,
            menu_item_multi_uuid: uuidv4(),

        }]
    })
    const [itemsList, setItemList] = useState([])
    const [editableAddons, setEditableAddon] = useState([])
    const [editableMulti, setEditableMulti] = useState([])
    const [Addons, setAddons] = useState({
        addon_max: "",
        addon_min: "",
        addon_title: "",
        id: uuidv4(),
        addon_item_details: [{
            item_uuid: "",
            menu_item_addon_uuid: "asdfasd",
            price: 0,
            id: uuidv4()
        }]
    })
    const [newMultiServing, setNewMultiServing] = useState(false)
    const [newAddon, setNewAddon] = useState(false)
    useEffect(() => {
        let itemdata = Menu?.category_and_items?.find(a => a.category_uuid === categoryId)?.menu_items?.find(a => a.item_uuid === itemId)
        console.log("--------------------", itemdata)

        setEditableMulti(itemdata?.menu_item_multi)
        setEditableAddon(itemdata?.menu_item_addons.map(a => ({ ...a, id: uuidv4(), addon_item_details: a.addon_item_details.map(b => ({ ...b, id: uuidv4() })) })))
    }, [])
    useEffect(() => {
        const getData = async () => {
            const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
            const tx = await db.transaction("item", "readwrite").objectStore("item");
            let data = await tx.getAll()
            setItemList(data)
        }
        getData()
    }, [])
    function submitHandler() {
        setCurrentMenu({
            ...Menu, category_and_items: Menu.category_and_items.map(a => a.category_uuid === categoryId ? {
                ...a, menu_items: a.menu_items.map(b => b.item_uuid === itemId ? {
                    ...b,
                    menu_item_multi: [...editableMulti, newMultiServing ? multiServing : []]
                        ?.map(c => ({ ...c, multi_item_details: c.multi_item_details?.filter(d => d.item_multi_name) }))
                        ?.filter(d => d.multi_item_details?.length && d.multi_title)||[],
                    menu_item_addons: [...editableAddons, newAddon ? { ...Addons, addon_min: Addons.addon_min || 0, addon_max: Addons.addon_max || 1 } : []]
                        ?.map(c => ({ ...c, addon_item_details: c.addon_item_details?.filter(d => d.item_uuid) }))
                        ?.filter(d => d.addon_item_details?.length && d.addon_title)||[]
                } : b)
            } : a)
        })
        close()


    }

    return (
        <div className='newCategory'>
            <div className='newCatContainer' style={{ width: "40vw", height: "fit-content" }}>
                <div className='newCatContainer_header'>
                    {/* <h2>Item Category</h2> */}
                    <XIcon className='closeicon' onClick={close} />
                </div>
                <div className='newCatContainer2' style={{ height: "140px", display: "flex", alignItems: "center", justifyContent: "space-between", flexDirection: "row", borderBottom: "2px solid black" }}>
                    <button style={{ fontSize: "15px", padding: "10px 20px" }} onClick={() => setNewAddon(true)}>Add Addon</button>
                    <button style={{ fontSize: "15px", padding: "10px 20px" }} onClick={() => setNewMultiServing(true)} >Add Multi Servings</button>
                </div>
                <div className='newCatContainer2'>
                    {editableAddons.length !== 0 || newAddon ? <h2 style={{ width: "100%", textAlign: "center" }}>Addons</h2> : ""}
                    {editableAddons?.map(item => (
                        <>
                            <div className='cat-inp' style={{ position: "relative" }}>

                                <input
                                    value={item.addon_title}
                                    onChange={(e) => setEditableAddon(editableAddons.map(a =>
                                        a.id === item.id ? ({ ...a, addon_title: e.target.value }) : a
                                    ))}
                                    placeholder="Set Title"
                                    maxLength={42}
                                    type='text'
                                    id='catname'
                                />
                                <DeleteIcon
                                    style={{
                                        position: "absolute",
                                        right: 0,
                                        cursor: "pointer"
                                    }}
                                    onClick={() =>
                                        setEditableAddon(editableAddons.map(a =>
                                            a.id === item.id ? ({}) : a
                                        ).filter(a => a.id))
                                    }
                                />
                                <div
                                    className='newCatContainer2'
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        flexDirection: "row"
                                    }}>
                                    <div
                                        style={{
                                            fontSize: "15px",
                                            padding: "10px 20px",
                                            background: "none",
                                            color: "#000",
                                            border: "1px solid",

                                        }}>
                                        Min:
                                        <input
                                            value={item.addon_min}
                                            onChange={(e) => setEditableAddon(editableAddons.map(a =>
                                                a.id === item.id ? ({ ...a, addon_min: e.target.value || 0 }) : a
                                            ))}
                                            placeholder="0"
                                            maxLength={42}
                                            type='text'
                                            id='catname'
                                            style={{
                                                background: "none",
                                                border: "none",
                                                width: "50px"
                                            }}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            fontSize: "15px",
                                            padding: "10px 20px",
                                            background: "none",
                                            color: "#000",
                                            border: "1px solid"
                                        }}  >
                                        Max:
                                        <input
                                            value={item.addon_max}
                                            onChange={(e) => setEditableAddon(editableAddons.map(a =>
                                                a.id === item.id ? ({ ...a, addon_min: e.target.value || 1 }) : a
                                            ))}
                                            placeholder="0"
                                            maxLength={42}
                                            type='text'
                                            id='catname'
                                            style={{
                                                background: "none",
                                                border: "none",
                                                width: "50px"
                                            }}
                                        />
                                    </div>
                                </div>
                                {item.addon_item_details?.map(itemA =>

                                    <div
                                        className='cat-inp'
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            flexDirection: "row"
                                        }}>
                                        {/* {console.log(itemsList?.find(c => c?.item_uuid === a?.item_uuid)?.item_name)} */}
                                        <div style={{ width: "200px", height: "fit-content" }}>

                                            <Select
                                                options={
                                                    itemsList.map((guest, index) => {
                                                        return {
                                                            label: guest.item_name,
                                                            value: guest.item_uuid,
                                                            key: guest._id,
                                                        }
                                                    })
                                                }
                                                placeholder="Item"
                                                maxMenuHeight="50"
                                                menuPlacement='top'
                                                value={itemsList.filter(c => c?.item_uuid === itemA?.item_uuid).map(c => ({
                                                    label: c.item_name,
                                                    value: c.item_uuid,
                                                    key: c._id,
                                                }))[0]}
                                                onChange={(e) => setEditableAddon(editableAddons.map(b =>
                                                    b.id === item.id ? ({
                                                        ...b, addon_item_details: b.addon_item_details.map(c =>
                                                            c.id === itemA.id ? ({ ...c, item_uuid: e.value }) : c)
                                                    }) : b
                                                ))}
                                            />
                                        </div>
                                        <input

                                            id="item_multi_price"

                                            placeholder='Price'
                                            value={itemA.price}
                                            onChange={(e) => setEditableAddon(editableAddons.map(b =>
                                                b.id === item.id ? ({
                                                    ...b, addon_item_details: b.addon_item_details.map(c =>
                                                        c.id === itemA.id ? ({ ...c, price: e.target.value || 0 }) : c)
                                                }) : b
                                            ))}
                                        /></div>
                                )}
                            </div>
                            {editableAddons.length ? <button onClick={() => setEditableAddon(editableAddons.map(b =>
                                b.id === item.id ? ({
                                    ...b, addon_item_details: [...b.addon_item_details, { ...addonItemDetailsDemoObject, id: uuidv4() }]
                                }) : b
                            ))} style={{ fontSize: "15px", padding: "10px 20px" }}>+Add Items</button> : ""}
                        </>


                    ))}

                    {newAddon ?
                        <div className='cat-inp'>
                            <input
                                value={Addons.addon_title}
                                onChange={(e) =>
                                    setAddons({
                                        ...Addons,
                                        addon_title: e.target.value
                                    })
                                }
                                placeholder="Set Title"
                                maxLength={42}
                                type='text'
                                id='catname'
                            />
                            <div
                                className='newCatContainer2'
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    flexDirection: "row"
                                }}>
                                <div
                                    style={{
                                        fontSize: "15px",
                                        padding: "10px 20px",
                                        background: "none",
                                        color: "#000",
                                        border: "1px solid",

                                    }}>
                                    Min:
                                    <input
                                        value={Addons.addon_min}
                                        onChange={(e) =>
                                            setAddons({
                                                ...Addons,
                                                addon_min: e.target.value
                                            })
                                        }
                                        placeholder="0"
                                        maxLength={42}
                                        type='text'
                                        id='catname'
                                        style={{
                                            background: "none",
                                            border: "none",
                                            width: "50px"
                                        }}
                                    />
                                </div>
                                <div
                                    style={{
                                        fontSize: "15px",
                                        padding: "10px 20px",
                                        background: "none",
                                        color: "#000",
                                        border: "1px solid"
                                    }}  >
                                    Max:
                                    <input
                                        value={Addons.addon_max}
                                        onChange={(e) =>
                                            setAddons({
                                                ...Addons,
                                                addon_max: e.target.value
                                            })
                                        }
                                        placeholder="0"
                                        maxLength={42}
                                        type='text'
                                        id='catname'
                                        style={{
                                            background: "none",
                                            border: "none",
                                            width: "50px"
                                        }}
                                    />
                                </div>
                            </div>
                            {Addons.addon_item_details.map(a =>

                                <div
                                    className='cat-inp'
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        flexDirection: "row"
                                    }}>
                                    {/* <input
                                        id="menu_item_addon_uuid"
                                        placeholder="Addon Item Name"
                                        value={a.item_multi_name}
                                        
                                    /> */}
                                    <div style={{ width: "200px", height: "fit-content" }}>
                                        <Select
                                            options={
                                                itemsList.map((guest, index) => {
                                                    return {
                                                        label: guest.item_name,
                                                        value: guest.item_uuid,
                                                        key: index,
                                                    }
                                                })
                                            }
                                            placeholder="Item"
                                            maxMenuHeight="50"
                                            menuPlacement='top'
                                            value={itemsList.filter(c => c?.item_uuid === a?.item_uuid).map(c => ({
                                                label: c.item_name,
                                                value: c.item_uuid,
                                                key: c._id,
                                            }))[0]}
                                            onChange={(e) => setAddons({
                                                ...Addons,
                                                addon_item_details: Addons.addon_item_details.map(b => {
                                                    if (b.id === a.id) {
                                                        return {
                                                            ...b,
                                                            item_uuid: e.value
                                                        }
                                                    } else return b

                                                })
                                            })}
                                        />
                                    </div>
                                    <input

                                        id="item_multi_price"

                                        placeholder='Price'
                                        value={a.price}
                                        onChange={(e) => setAddons({
                                            ...Addons,
                                            addon_item_details: Addons.addon_item_details.map(b => {
                                                if (b.id === a.id) {
                                                    return {
                                                        ...b,
                                                        price: e.target.value || 0
                                                    }
                                                } else {

                                                    return b
                                                }

                                            })
                                        })}
                                    /></div>
                            )}
                        </div>
                        : ""}
                    {newAddon ? <button onClick={() => setAddons({ ...Addons, addon_item_details: [...Addons.addon_item_details, { ...addonItemDetailsDemoObject, id: uuidv4() }] })} style={{ fontSize: "15px", padding: "10px 20px" }}>+Add Items</button> : ""}



                    {editableMulti.length !== 0 || newMultiServing ? <h2 style={{ width: "100%", textAlign: "center" }}>Multi Serving</h2> : ""}
                    {editableMulti.length !== 0 && editableMulti?.map(item => (
                        <>
                            <div className='cat-inp' style={{ position: "relative" }}>
                                {console.log("-----", item)}
                                <input
                                    value={item.multi_title}
                                    onChange={(e) => setEditableMulti(editableMulti.map(a =>
                                        a._id === item._id ? ({ ...a, multi_title: e.target.value }) : a
                                    ))}
                                    placeholder="Set Title"
                                    maxLength={42}
                                    type='text'
                                    id='catname'
                                />
                                <DeleteIcon
                                    style={{
                                        position: "absolute",
                                        right: 0,
                                        cursor: "pointer"
                                    }}
                                    onClick={() =>
                                        setEditableMulti(editableMulti?.map(a =>
                                            a._id === item._id ? ({}) : a
                                        )?.filter(a => a._id))
                                    }
                                />
                                <div
                                    className='newCatContainer2'
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        flexDirection: "row"
                                    }}>
                                    <button
                                        style={{
                                            fontSize: "15px",
                                            padding: "10px 20px",
                                            background: "none",
                                            color: "#000",
                                            border: "1px solid"
                                        }}>
                                        Min:
                                        {item?.multi_min || 1}
                                    </button>
                                    <button
                                        style={{
                                            fontSize: "15px",
                                            padding: "10px 20px",
                                            background: "none",
                                            color: "#000",
                                            border: "1px solid"
                                        }}  >
                                        Max: {item?.multi_max || 1}
                                    </button>
                                </div>
                                {item.multi_item_details.map(a =>
                                    <div className='cat-inp' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexDirection: "row" }}>
                                        <input



                                            placeholder="Serving Name"
                                            value={a.item_multi_name}
                                            onChange={(e) => setEditableMulti(editableMulti.map(b =>
                                                b._id === item._id ? ({
                                                    ...b, multi_item_details: b.multi_item_details.map(c =>
                                                        c._id === a._id ? ({ ...b, _id: a._id, item_multi_name: e.target.value }) : c)
                                                }) : b
                                            ))}
                                        />
                                        <input

                                            id="item_multi_price"

                                            placeholder='Price'
                                            value={a.item_multi_price}
                                            onChange={(e) => setEditableMulti(editableMulti.map(b =>
                                                b._id === item._id ? ({
                                                    ...b, multi_item_details: b.multi_item_details.map(c =>
                                                        c._id === a._id ? ({ ...b, _id: a._id, item_multi_price: e.target.value || 0 }) : c)
                                                }) : b
                                            ))}
                                        /></div>
                                )}

                            </div>
                            {
                                editableMulti.length ? <button onClick={() => setEditableMulti(editableMulti.map(b =>
                                    b._id === item._id ? ({
                                        ...b, multi_item_details: [...b.multi_item_details, { ...multiItemDetailsDemoObject, _id: uuidv4() }]
                                    }) : b
                                ))}
                                    style={{ fontSize: "15px", padding: "10px 20px" }}
                                >
                                    +Add Serving
                                </button>
                                    : ""
                            }</>
                    ))}

                    {newMultiServing ?
                        <div className='cat-inp'>
                            <input
                                value={multiServing.multi_title}
                                onChange={(e) =>
                                    setMultiServing({
                                        ...multiServing,
                                        multi_title: e.target.value
                                    })
                                }
                                placeholder="Set Title"
                                maxLength={42}
                                type='text'
                                id='catname'
                            />
                            <div
                                className='newCatContainer2'
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    flexDirection: "row"
                                }}>
                                <button
                                    style={{
                                        fontSize: "15px",
                                        padding: "10px 20px",
                                        background: "none",
                                        color: "#000",
                                        border: "1px solid"
                                    }}>
                                    Min:
                                    {multiServing.multi_min}
                                </button>
                                <button
                                    style={{
                                        fontSize: "15px",
                                        padding: "10px 20px",
                                        background: "none",
                                        color: "#000",
                                        border: "1px solid"
                                    }}  >
                                    Max: {multiServing.multi_max}
                                </button>
                            </div>
                            {multiServing.multi_item_details.map(a =>

                                <div className='cat-inp' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexDirection: "row" }}>
                                    <input
                                        placeholder="Serving Name"
                                        value={a.item_multi_name}
                                        onChange={(e) => setMultiServing({
                                            ...multiServing,
                                            multi_item_details: multiServing.multi_item_details.map(b => {
                                                if (b.menu_item_multi_uuid === a.menu_item_multi_uuid) {

                                                    return {
                                                        ...b,
                                                        item_multi_name: e.target.value
                                                    }
                                                } else return b

                                            })
                                        })}
                                    />
                                    <input
                                        id="item_multi_price"

                                        placeholder='Price'
                                        value={a.item_multi_price}
                                        onChange={(e) => setMultiServing({
                                            ...multiServing,
                                            multi_item_details: multiServing.multi_item_details.map(b => {
                                                if (b.menu_item_multi_uuid === a.menu_item_multi_uuid) {
                                                    console.log(e.target.value)
                                                    return {
                                                        ...b,
                                                        item_multi_price: e.target.value || 0
                                                    }
                                                } else {

                                                    return b
                                                }

                                            })
                                        })}
                                    /></div>
                            )}
                        </div>
                        : ""}
                    {newMultiServing ? <button onClick={() => setMultiServing({ ...multiServing, multi_item_details: [...multiServing.multi_item_details, { ...multiItemDetailsDemoObject, menu_item_multi_uuid: uuidv4() }] })} style={{ fontSize: "15px", padding: "10px 20px" }}>+Add Serving</button> : ""}
                    <button onClick={submitHandler}>Update</button></div>
            </div>
        </div>

    )
}


export default ItemEditPopup
